import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const ElementWrapper = (props) => {
    const { component: Component, ...rest } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    const history = {
        push: (path) => navigate(path),
        replace: (path) => navigate(path, { replace: true }),
        goBack: () => navigate(-1)
    };

    const match = {
        params: params,
    };

    return <Component {...rest} history={history} location={location} match={match} navigate={navigate} />;
};
